import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { VolumeStack } from './VolumeStack';

/** Replace with the live checkout URL (platform not defined yet). */
const CHECKOUT_URL = 'https://52-weeks-of-barre-your-whole-year-of-barre-classes-already-mapp.impultienda.ar/checkout';
const included = ['6 volumes · 52 weeks mapped', '5 instant-use bonuses', '300 landscape pages, print or phone', '30, 45 and 55-minute class versions', '16 planning worksheets', 'Lifetime access to your files'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-blush text-ink" data-id="element-179" data-mp="25t0tnkjl0d7g">
      <div className="max-w-2xl mx-auto px-5 py-16 sm:py-20" data-id="element-180" data-mp="20rtkbh1sj5yo">
        <div className="text-center" data-id="element-181" data-mp="3h6lf20mespb5">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold-deep" data-id="element-182" data-mp="3h5jtv3boimfp">
            Complete package
          </p>
          <h2 id="pricing-heading" className="mt-3 font-display font-semibold text-plum text-3xl sm:text-5xl" data-id="element-183" data-mp="3vzp4rftr067y">
            Everything you need to teach the{' '}
            <span className="italic" data-id="element-184" data-mp="9si87x0pwf0m">next 52 weeks</span>
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border border-blush-dark bg-white shadow-card" data-id="element-185" data-mp="9qe2ran677y8">
          <div className="bg-plum px-5 py-5 text-center" data-id="element-186" data-mp="3d8z5e13dz1ju">
            <h3 className="font-display text-xl font-semibold text-white sm:text-2xl" data-id="element-187" data-mp="3daikvph7x8kk">
              52 Weeks of Barre — Complete Package
            </h3>
            <p className="mt-1 text-[13px] font-semibold text-gold-hover" data-id="element-188" data-mp="3n6llgqwf8z5e">
              6 Volumes + 5 Bonuses
            </p>
          </div>

          <div className="p-5 sm:p-7" data-id="element-189" data-mp="3rzeonac8rzfd">
            <div className="mx-auto max-w-lg rounded-2xl bg-plum-deep" data-id="element-190" data-mp="2uihcnwik05yh">
              <VolumeStack data-id="element-191" data-mp="2ugdbvnfybn2f" />
            </div>

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-192" data-mp="2zh13aa83e5x6">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-sm" data-id="element-193" data-mp="2rg333zwctslv">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-gold/20" data-id="element-194" data-mp="2mi1l7ianzzbz">
                    <CheckIcon className="h-3 w-3 text-gold-deep" aria-hidden="true" data-id="element-195" data-mp="315mmr7rw5qhs" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-cream-dark pt-6 text-center" data-id="element-196" data-mp="28jts5lgr1i63">
              <p className="text-[13px] text-ink-soft" data-id="element-197" data-mp="23kqqmazz9u2v">
                Total value{' '}
                <span className="text-ink-muted line-through" data-id="element-198" data-mp="2ihrdo17850v0">$90 USD</span>
              </p>
              <div className="mt-1 flex items-start justify-center gap-1 text-plum" data-id="element-199" data-mp="2dfilv86384uh">
                <span className="mt-2.5 font-display text-3xl" data-id="element-200" data-mp="3tu0n3u6gcywi">$</span>
                <span className="font-display font-semibold text-6xl leading-[0.9] sm:text-7xl" data-id="element-201" data-mp="3ows27ltx6grk">
                  27
                </span>
                <span className="mt-3 text-[13px] font-semibold text-ink-muted" data-id="element-202" data-mp="8sqt1wrcclo">
                  USD
                </span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-203" data-mp="3nfcxkkd18f3q">
                <span className="rounded-full border border-gold bg-gold px-3 py-1 text-[10px] font-semibold uppercase tracking-widest text-gold-ink" data-id="element-204" data-mp="3nh68wcylbni2">
                  Save $63
                </span>
                <span className="rounded-full border border-cream-dark px-3 py-1 text-[10px] font-semibold uppercase tracking-widest text-ink-soft" data-id="element-205" data-mp="j2y77p0ct0du">
                  One-time payment
                </span>
                <span className="rounded-full border border-cream-dark px-3 py-1 text-[10px] font-semibold uppercase tracking-widest text-ink-soft" data-id="element-206" data-mp="a6qmgagy5bob">
                  No subscription
                </span>
              </div>

              <CtaButton href={CHECKOUT_URL} className="mt-5" data-id="element-207" data-mp="16qzdssdz26qm">
                Get 52 Weeks of Barre — only $27
              </CtaButton>

              <p className="mt-3 text-xs text-ink-muted" data-id="element-208" data-mp="3f93fvznk1jmy">
                Backed by the 7-day money-back guarantee
              </p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-ink-soft" data-id="element-209" data-mp="3aas2jey1wqzz">
                <li className="flex items-center gap-1.5" data-id="element-210" data-mp="3180rhg937x8v">
                  <LockIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-211" data-mp="319k6l3j0c292" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-212" data-mp="3szoz5pgx7vld">
                  <ZapIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-213" data-mp="3o7f1fn9kdr8j" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-214" data-mp="kjddfohy8vk9">
                  <ShieldCheckIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-215" data-mp="kkybvp7dwyne" />
                  7-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-ink-muted" data-id="element-216" data-mp="23ern3bhbfakh">
          Price in USD. You&apos;ll be charged the equivalent in your local
          currency.
        </p>
      </div>
    </section>;
}